// +----------------------------------------------------------------------
// | 登录页
// +----------------------------------------------------------------------
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import '../../css/auth.less';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state && location.state.from) || '/';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    const name = username.trim();
    if (!name) {
      setError('请填写用户名');
      return;
    }
    if (!password) {
      setError('请填写密码');
      return;
    }

    setError('');
    setLoading(true);
    try {
      await login({ username: name, password });
      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || '登录失败，检查一下用户名和密码');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <div className="auth-panel">
        <div className="auth-brand">
          <span className="auth-brand-name">想想</span>
          <span className="auth-brand-sub">有啥纠结的，扔过来。</span>
        </div>

        <form className="auth-card" onSubmit={handleSubmit}>
          <h2 className="title-lg">欢迎回来</h2>
          <p className="muted" style={{ margin: '6px 0 20px' }}>
            登录后才能把纠结存下来，慢慢变懂你。
          </p>

          {error && <div className="auth-error">{error}</div>}

          <div className="field">
            <label htmlFor="username">用户名</label>
            <input
              id="username"
              className="input"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="你的用户名"
            />
          </div>

          <div className="field">
            <label htmlFor="password">密码</label>
            <input
              id="password"
              className="input"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="你的密码"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-block auth-submit" disabled={loading}>
            {loading ? '登录中…' : '登录'}
          </button>

          <div className="auth-switch">
            还没有账号？<Link to="/register">注册一个</Link>
          </div>
        </form>

        <Link to="/" className="auth-back">
          ← 先随便看看
        </Link>
      </div>
    </div>
  );
}
